module.exports = __webpack_public_path__ + "img/30_days_money_guarantee.d280834d.png";